import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import store from './store'
import VueCookies from 'vue-cookies'
import { i18n, loadLocale } from './i18n'
import vue3GoogleLogin from 'vue3-google-login'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { initGTM } from './gtm'

import 'bootstrap/dist/css/bootstrap.min.css'

import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

import PrimeVue from 'primevue/config'
import 'primeicons/primeicons.css'
import Aura from '@primeuix/themes/aura'

import VueCountdown from '@chenfengyuan/vue-countdown'

// Axios defaults
axios.defaults.withCredentials = true
axios.defaults.baseURL = import.meta.env.VITE_AXIOS_BASE_URL

initGTM()

axios.interceptors.response.use(
    response => response,
    error => {
        const status = error?.response?.status
        if (status === 401 || status === 403) {
            document.cookie = 'token=; Max-Age=0; path=/'
        }
        return Promise.reject(error)
    },
)

function normalizeBase(url) {
    return String(url || '').replace(/\/+$/, '')
}

function buildImageUrl(path) {
    if (!path) return ''

    if (/^https?:\/\//i.test(path)) {
        return path
    }

    const base = normalizeBase(import.meta.env.VITE_IMAGE_BASE_URL)
    const cleanPath = String(path).replace(/^\/+/, '')

    return `${base}/${cleanPath}`
}

function resolveInitialLang() {
    const stored = window.localStorage.getItem('defaultLang')
    if (stored) return stored

    const hostname = window.location.hostname.replace(/^www\./, '').replace(/\.$/, '')

    const bgHost = import.meta.env.VITE_BG_HOSTNAME
    const bgCode = import.meta.env.VITE_BG_LANGUAGE_CODE || 'bg'
    const enCode = import.meta.env.VITE_EN_LANGUAGE_CODE || 'en'

    if (bgHost && hostname === bgHost) return bgCode
    return enCode
}

function createAndMountApp() {
    const app = createApp(App)

    app.config.globalProperties.$imageUrl = buildImageUrl
    app.config.globalProperties.$axios = axios

    app.component(VueCountdown.name, VueCountdown)
    app.component('QuillEditor', QuillEditor)

    app
        .use(store)
        .use(i18n)
        .use(router)
        .use(VueCookies)
        .use(vue3GoogleLogin, {
            clientId: '409726691484-90e7dpu3k8j7bt3303d7thn9nrt1b44c.apps.googleusercontent.com',
        })
        .use(VueReCaptcha, {
            siteKey: '6LfcMA8qAAAAADzsn4m6hztDXTZjuhYKxx8yNLbp',
            loaderOptions: { autoHideBadge: true },
        })
        // .use(PrimeVue, { theme: { preset: Aura } })
        .mount('#app')

    return app
}

async function bootstrap() {
    const lang = resolveInitialLang()

    // Load i18n messages BEFORE mounting
    await loadLocale(lang)
    i18n.global.locale.value = lang
    axios.defaults.headers.common['X-Accept-Language'] = lang
    document.documentElement.setAttribute('lang', lang)
    window.localStorage.setItem('defaultLang', lang)

    // Auth init before mount (your original intention)
    await store.dispatch('user/initAuth')

    createAndMountApp()
}

bootstrap().catch(err => {
    console.error('App bootstrap failed:', err)
    createAndMountApp()
})